import axios from "axios";

// Default base URL

// Create default API instance
const api = axios.create({
  baseURL: "https://apps.youthplus.ng",
  // headers: {
  //   "Content-Type": "application/json",
  // },
  validateStatus: function (status) {
    return status >= 200 && status < 300; // This should include 201
  },
});

// Create special API instance for specific endpoints
const quickTellerApi = axios.create({
  baseURL: "https://transport-api.interswitchng.com",
  validateStatus: function (status) {
    return status >= 200 && status < 300; // This should include 201
  },
  //  "https://qtt-transport-service.qa.interswitchng.com",

  // headers: {
  //   "Content-Type": "application/json",
  // },
});

export { api, quickTellerApi };
